import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { usePlotlyConfig } from '../../hooks/useResponsive';


const AssociatedTime36 = () => {

    const [data, setData] = useState([]);
    const { getPlotlyConfig, getPlotlyLayout } = usePlotlyConfig();

    useEffect(() => {
        // Substitua pelo link CSV da sua planilha
        const sheetUrl = process.env.REACT_APP_SHEET_1_URL

        fetch(sheetUrl)
            .then((response) => response.text())
            .then((csvText) => {
                const rows = csvText.split('\n').map((row) => row.split(','));
                setData(rows);
            })
            .catch((error) => console.error('Error fetching data:', error));
    }, []);

    if (data.length === 0) {
        return null; // Retorna null em vez de spinner, deixa o skeleton da página principal gerenciar o loading
    }

    const xValues = data.slice(1).map((row) => {
        const value = row[0];
        return typeof value === 'string' ? value : String(value); // Garante que seja uma string
    });


    const yValues1 = data.slice(1).map((row) => {
        const value = parseFloat(row[1]);
        return isNaN(value) ? null : value; // Substitui valores inválidos por `null`
    });

    const yValues2 = data.slice(1).map((row) => {
        const value = parseFloat(row[2]);
        return isNaN(value) ? null : value; // Substitui valores inválidos por `null`
    });


/*     // Verifica se xValues é um array de strings ou datas
    console.log(Array.isArray(xValues) && xValues.every(val => typeof val === 'string' || val instanceof Date));

    // Verifica se yValues1 e yValues2 são arrays de números
    console.log(Array.isArray(yValues1) && yValues1.every(val => typeof val === 'number'));
    console.log(Array.isArray(yValues2) && yValues2.every(val => typeof val === 'number'));



    console.log("xValues - associatedTime36:", xValues)
    console.log("yValues1 - associatedTime36:", yValues1)
    console.log("yValues2 - associatedTime36:", yValues2) */


    return (
        <div className='container-fluid vh-100 w-100  justify-content-center align-items-center'>
            <Plot
                config={getPlotlyConfig()}
                data={[
                    {
                        x: xValues,
                        y: yValues1,
                        type: 'bar',
                        marker: { color: '#1A9EE0' },
                        name: 'Nº de Ex Alunos',
                        text: yValues1, // Rótulos nas barras
                        textposition: 'auto', // Posição dos rótulos automaticamente sobre as barras
                    },
                    {
                        x: xValues,
                        y: yValues2,
                        type: 'bar',
                        marker: { color: 'black' },
                        name: 'Contribuintes do Fundo',
                        text: yValues2, // Rótulos nas barras
                        textposition: 'auto', // Posição dos rótulos automaticamente sobre as barras

                    },
                ]}
                layout={getPlotlyLayout({
                    barmode: 'overlay',
                    width: 1200,
                    legend: {
                        x: 0,
                        y: 1,
                        traceorder: 'normal',
                        font: {
                          family: 'sans-serif',
                          size: 12,
                          color: '#000'
                        },
                        bgcolor: '#E2E2E2',
                        bordercolor: '#FFFFFF',
                        borderwidth: 2
                      },
                    height: 500,
                    title: 'Número de Ex-alunos e Contribuintes nos últimos 36 meses',
                    yaxis: {
                        title: 'Quantidade',
                        side: 'right'
                    },
                    xaxis: {
                        tickangle: -45,
                        title: 'Tempo',
                        type: 'date',
                        range: [new Date(new Date().setMonth(new Date().getMonth() - 36)), new Date()],
                    }
                })}

            />
        </div>
    );
}

export default AssociatedTime36